module.exports = __webpack_public_path__ + "9371acf0461f2e297115b8aa4f649da4.svg";